import {
  Box,
  BoxProps,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { SparkButton, SparkImageLoader } from 'sharedComponents/UI';
import { usePopover } from 'hooks/common';
import DownloadIcon from 'components/SVG/DownloadIcon';
import { useSparkRunByID } from 'hooks/SparkRuns/useSparkRunByID';
import { useSparkRunsStatusTypes } from 'hooks/EntityTypes/useSparkRunsStatusTypes';
import { getTimeFromDate } from 'utilities/time';
import { DotsHorizontal } from 'components/SVG';
import { useSparkRunStore } from 'stores';

const SparkRunMenuItem = ({
  sparkRunID,
  closeParent,
}: {
  sparkRunID: string;
  closeParent: () => void;
}) => {
  const { open, openPopover, closePopover, anchorEl } = usePopover();
  const { sparkRun } = useSparkRunByID(sparkRunID);
  const { idMap } = useSparkRunsStatusTypes();
  const iconURL =
    idMap?.[sparkRun?.attributes.sparkRunStatusTypeID || ''].attributes.iconURL;
  const setSelectedSparkRunID = useSparkRunStore(
    (state) => state.setSelectedSparkRunID
  );
  const selectedSparkRunID = useSparkRunStore(
    (state) => state.selectedSparkRunID
  );
  const openFormSideBar = useSparkRunStore((state) => state.openFormSideBar);

  const handleClick = () => {
    setSelectedSparkRunID(sparkRunID);
    closeParent();
  };

  const handleMenuItemClick = (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    // open spark run form from side bar
    setSelectedSparkRunID(sparkRunID);
    openFormSideBar();
    closePopover();
    closeParent();
  };
  return (
    <MenuItem
      onClick={handleClick}
      selected={selectedSparkRunID === sparkRunID}
    >
      <Box display='flex' alignItems='center' gap={1}>
        <SparkImageLoader src={iconURL} width={20} height={20} />
        <Typography variant='body2' marginTop={0.5}>
          {getTimeFromDate(sparkRun?.attributes.createdAt || '')}
        </Typography>
        <IconButton
          onClick={openPopover}
          sx={{ margin: 0, '& path': { stroke: 'black' } }}
        >
          <DotsHorizontal />
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={closePopover}>
          <MenuItem onClick={handleMenuItemClick}>
            <Box
              display='flex'
              gap={2}
              justifyContent='center'
              alignItems='center'
            >
              <DownloadIcon width='20' height='20' />
              <Typography variant='body2' marginTop={0.5}>
                Input
              </Typography>
            </Box>
          </MenuItem>
        </Menu>
      </Box>
    </MenuItem>
  );
};

type SparkRunsCollectionProps = {
  collectiveSparkRunIDs: string[];
  boxStyles?: BoxProps['sx'];
};

function SparkRunsCollection({
  collectiveSparkRunIDs,
  boxStyles = {},
}: SparkRunsCollectionProps) {
  const { open, openPopover, closePopover, anchorEl } = usePopover();

  return (
    <>
      <SparkButton
        sx={{ zIndex: 200, bgcolor: 'white', ...boxStyles }}
        startIcon={<PlayArrowIcon />}
        onClick={openPopover}
      >
        <Typography>{collectiveSparkRunIDs.length}</Typography>
      </SparkButton>
      <Menu anchorEl={anchorEl} open={open} onClose={closePopover}>
        {collectiveSparkRunIDs.map((sparkRunID) => (
          <SparkRunMenuItem
            sparkRunID={sparkRunID}
            closeParent={closePopover}
          />
        ))}
      </Menu>
    </>
  );
}

export default SparkRunsCollection;
